export const getBodyStyle = (theme) => {
    return '.body { font-family: ' + theme.font + ', sans-serif; background: ' + theme.body.background + '; color:' + theme.body.text + '; }'
        + ' .filters { background: ' + theme.filters.background + '; color:' + theme.filters.text + '; }'
        + ' .banner { background: ' + theme.banner.background + '; color:' + theme.banner.text + '; }'
        + ' .footer { background: ' + theme.footer.background + '; color:' + theme.footer.text + '; }'
        + ' .footer a { color:' + theme.footer.text + '; text-decoration: none; }'
        + ' .footer a:hover { color:' + theme.footer.accent + '; }'
        + ' .icon rect { fill: ' + theme.filters.accentTwo + '; }'
        + ' .icon:hover rect, .icon:focus rect { fill: ' + theme.filters.accent + '; }'
        + ' .icon path { fill: ' + theme.filters.text + '; }'
        + ' a, .link-text { color: ' + theme.body.accent + '; }'
        ;
};

export const secondaryBanner = {
    height         : '48px',
    width          : '100%',
    margin         : '-2px 0 0 0',
    textAlign      : 'left',
    display        : 'inline-block',
    padding        : '10px',
    fontSize       : '14px',
    lineHeight     : '28px'
};

export const secondaryIcon = {
    style: {
        fontSize: '28px'
    },
    color: 'white'
};

export const actionIcon = {
    fontSize: '38px'
};

export const tags = {
    chip: {
        margin: '8px 4px 8px 0'
    },
    wrapper: {
        marginTop: '15px',
        display: 'flex',
        flexWrap: 'wrap'
    }
};




// WEBPACK FOOTER //
// ./src/css/Styles.js